<!-- eslint-disable vue/no-v-html -->
<template>
  <div>
    <div
      v-if="loader"
      class="fixed inset-0 flex items-center justify-center bg-white z-50"
    >
      <img
        src="@/assets/imgs/tuin_loader_v2.gif"
        alt="cargando..."
        class="w-[500px]"
      >
    </div>
    <div class="flex">
      <ToastAlert
        :is-active="toastAlert"
        :type="typeMsg"
        :message="msg"
      />
    </div>
    <div class="sm:px-28 pb-[90px]">
      <div class="my-8">
        <div class="flex flex-col lg:flex-row lg:justify-between lg:items-center w-full">
          <!-- Breadcrumb -->
          <nav class="w-full lg:w-1/2" aria-label="Breadcrumb">
            <ol class="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
              <li class="inline-flex items-center">
                <a href="/bolsa-inmobiliaria" class="inline-flex items-center text-sm font-medium text-custom_gray hover:text-tuin-100 uppercase">
                  {{ property.property_type }}
                </a>
              </li>
              <li>
                <div class="flex items-center">
                  <svg class="rtl:rotate-180 w-3 h-3 text-gray-400 mx-1" aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="m1 9 4-4-4-4" />
                  </svg>
                  <a href="/bolsa-inmobiliaria" class="ms-1 text-sm font-medium text-custom_gray hover:text-tuin-100 uppercase">
                    {{ property.property_movement }}
                  </a>
                </div>
              </li>
              <li aria-current="page">
                <div class="flex items-center">
                  <svg class="rtl:rotate-180 w-3 h-3 text-gray-400 mx-1" aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="m1 9 4-4-4-4" />
                  </svg>
                  <a href="#" class="ms-1 text-sm font-medium text-custom_gray uppercase">
                    {{ property.property_name }}
                  </a>
                </div>
              </li>
            </ol>
          </nav>
          <!-- Reportar propiedad -->
          <div class="only-dest w-full lg:w-1/2 mt-4 lg:mt-0 lg:text-right flex justify-end text-custom_gray text-sm font-medium">
            <button @click="showReportModal = true" class="hover:underline mr-4">Reportar propiedad</button>
            <button @click="handleAddPropertyClick" class="hover:underline">+ Agregar a mis propiedades</button>
          </div>
        </div>
      </div>
      <div class="flex flex-wrap">
        <!--New Gallery-->
        <GalleryComponent :images="pictures" />
      </div>
      <div class="only-mob">
        <div class="my-4">
          <span class="inline-flex bg-custom_black2 text-white text-sm font-semibold rounded-md px-3 py-1">
            {{ property.property_type }}
          </span>
          <span 
            class="inline-flex bg-tuin_hover text-white text-sm font-semibold rounded-md px-3 py-1 ml-2"
          >
            {{ property.property_movement}}
          </span>
        </div>
        <div class="flex flex-row w-full justify-between items-center mt-4">
          <!-- Texto a la izquierda -->
          <div class="w-2/3">
            <button class="text-left text-custom_gray text-sm font-medium hover:underline" @click="showReportModal = true">Reportar propiedad</button>
            <button class="text-left text-custom_gray text-sm font-medium hover:underline" @click="handleAddPropertyClick">+ Agregar a mis propiedades</button>
          </div>
          <!-- Botón a la derecha -->
          <div class="flex justify-end items-center">
            <button @click="callActionLog(proeprtyId, 7, 'Usuario hizó clic en el botón de compartir propiedad desde Adesores'); showShareModal = true">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M13.5768 11.2506C13.0714 11.2528 12.5828 11.4387 12.1964 11.7756C12.156 11.7334 12.1115 11.6957 12.0634 11.6632L6.76943 8.79638C6.71613 8.77308 6.66042 8.75619 6.60339 8.74604C6.60948 8.68131 6.62252 8.61928 6.62252 8.55366C6.62252 8.54557 6.62252 8.53838 6.62252 8.53118C6.67974 8.525 6.73623 8.51295 6.79116 8.49522L11.9252 6.21631C11.976 6.18779 12.0238 6.15373 12.0677 6.11472C12.4287 6.4749 12.8989 6.69489 13.3988 6.73736C13.8987 6.77983 14.3974 6.64218 14.8104 6.34775C15.2233 6.05332 15.525 5.62024 15.6644 5.12197C15.8038 4.62369 15.7722 4.0909 15.575 3.61396C15.3779 3.13701 15.0272 2.74528 14.5826 2.50521C14.138 2.26514 13.6268 2.1915 13.1356 2.29679C12.6445 2.40208 12.2037 2.67981 11.888 3.08289C11.5723 3.48596 11.4012 3.98955 11.4036 4.50824C11.4032 4.51573 11.4032 4.52323 11.4036 4.53072C11.3463 4.5372 11.2898 4.54954 11.235 4.56758L6.10095 6.84559C6.0502 6.87433 6.00243 6.90837 5.95838 6.94718C5.65798 6.64068 5.27795 6.43101 4.8645 6.34365C4.45104 6.25629 4.02194 6.295 3.62936 6.45509C3.23678 6.61517 2.8976 6.88973 2.65306 7.24539C2.40851 7.60106 2.26912 8.02253 2.25183 8.45858C2.23454 8.89462 2.34008 9.32648 2.55564 9.70167C2.7712 10.0768 3.08749 10.3792 3.46608 10.572C3.84467 10.7648 4.26926 10.8397 4.68825 10.7877C5.10723 10.7356 5.50258 10.5588 5.82625 10.2788C5.86659 10.3211 5.91117 10.3587 5.95925 10.3912L11.2532 13.258C11.3055 13.2859 11.3606 13.3076 11.4175 13.3228C11.4175 13.3821 11.4001 13.4396 11.4001 13.5025C11.4001 13.9471 11.5276 14.3816 11.7664 14.7512C12.0052 15.1208 12.3446 15.4088 12.7417 15.5789C13.1388 15.749 13.5757 15.7935 13.9973 15.7068C14.4189 15.6201 14.8061 15.406 15.11 15.0917C15.414 14.7774 15.6209 14.377 15.7048 13.941C15.7886 13.505 15.7456 13.0532 15.5811 12.6425C15.4166 12.2318 15.1381 11.8808 14.7807 11.6339C14.4233 11.3869 14.0032 11.2551 13.5733 11.2551L13.5768 11.2506Z" fill="#737373"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
      <!-- Tabs fijos para desktop -->
      <div class="only-dest sticky top-0 bg-white z-10 border-b border-gray-200">
        <div class="flex flex-row w-full justify-between items-center">
          <div class="md:w-100%">
            <!--New Tabs--> 
            <div class="text-sm font-medium text-center text-gray-500">
                <ul class="flex flex-wrap -mb-px">
                    <li class="me-2">
                        <a href="#" @click.prevent="scrollToSection('propiedad')"
                            :class="['inline-block p-4 border-b-2 border-transparent rounded-t-lg text-gray-600 ', activeTab === 'propiedad' ? 'text-tuin-100 border-tuin-100 hover:text-tuin-100' : '']"
                        >Propiedad</a>
                    </li>
                    <li class="me-2">
                        <a href="#" @click.prevent="scrollToSection('caracteristicas')"
                            :class="['inline-block p-4 border-b-2 border-transparent rounded-t-lg text-gray-600 ', activeTab === 'caracteristicas' ? 'text-tuin-100 border-tuin-100 hover:text-tuin-100' : '']"
                        >Características</a>
                    </li>
                    <li class="me-2" v-if="description !== '<p> </p>'">
                        <a href="#" @click.prevent="scrollToSection('descripcion')"
                            :class="['inline-block p-4 border-b-2 border-transparent rounded-t-lg text-gray-600 ', activeTab === 'descripcion' ? 'text-tuin-100 border-tuin-100 hover:text-tuin-100' : '']"
                        >Descripción</a>
                    </li>
                    <li class="me-2" v-if="characters_additional != '<p> </p>' && characters_additional != null">
                        <a href="#" @click.prevent="scrollToSection('additional_characteristics')"
                            :class="['inline-block p-4 border-b-2 border-transparent rounded-t-lg text-gray-600', activeTab === 'additional_characteristics' ? 'text-tuin-100 border-tuin-100 hover:text-tuin-100' : '']"
                        >Otras características</a>
                    </li>
                    <li class="me-2" v-if="amenities_list.length > 0">
                        <a href="#" @click.prevent="scrollToSection('amenidades')"
                            :class="['inline-block p-4 border-b-2 border-transparent rounded-t-lg text-gray-600', activeTab === 'amenidades' ? 'text-tuin-100 border-tuin-100 hover:text-tuin-100' : '']"
                        >Amenidades</a>
                    </li>
                    <li class="me-2" v-if="friendly_list.length > 0">
                        <a href="#" @click.prevent="scrollToSection('friendly')"
                            :class="['inline-block p-4 border-b-2 border-transparent rounded-t-lg text-gray-600', activeTab === 'friendly' ? 'text-tuin-100 border-tuin-100 hover:text-tuin-100' : '']"
                        >Friendly</a>
                    </li>
                    <li class="me-2" v-if="requirement_list.length > 0">
                        <a href="#" @click.prevent="scrollToSection('requisitos')"
                            :class="['inline-block p-4 border-b-2 border-transparent rounded-t-lg text-gray-600', activeTab === 'requisitos' ? 'text-tuin-100 border-tuin-100 hover:text-tuin-100' : '']"
                        >Requisitos</a>
                    </li>
                    <li class="me-2" v-if="services_list.length > 0">
                        <a href="#" @click.prevent="scrollToSection('servicios')"
                            :class="['inline-block p-4 border-b-2 border-transparent rounded-t-lg text-gray-600', activeTab === 'servicios' ? 'text-tuin-100 border-tuin-100 hover:text-tuin-100' : '']"
                        >Servicios</a>
                    </li>
                    <li class="me-2" v-if="property.video_url">
                        <a href="#" @click.prevent="scrollToSection('video')"
                            :class="['inline-block p-4 border-b-2 border-transparent rounded-t-lg text-gray-600', activeTab === 'video' ? 'text-tuin-100 border-tuin-100 hover:text-tuin-100' : '']"
                        >Video</a>
                    </li>
                    <li v-if="property.property_lt && property.property_ln">
                        <a href="#" @click.prevent="scrollToSection('mapa')"
                            :class="['inline-block p-4 border-b-2 border-transparent rounded-t-lg text-gray-600', activeTab === 'mapa' ? 'text-tuin-100 border-tuin-100 hover:text-tuin-100' : '']"
                        >Mapa</a>
                    </li>
                </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-wrap mt-4 lg:flex-nowrap gap-4 pb-0">
        <div class="w-full lg:w-2/3 bg-white relative">
          <!--Propiedad-->
          <div id="propiedad" class="flex flex-col border-b border-[#E5E7EB]">
            <!-- Componente -->
            <div>
              <CardMovementComponent :property="property" />
            </div>

          <!-- Nombre -->
          <h1 class="text-left text-xl md:text-xl font-medium md:mt-2">
            {{ property.property_name }}
          </h1>

          <!-- Dirección -->
          <p class="flex items-center text-gray-400 text-sm font-medium">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
              <path d="M8.00048 10.2414C7.47306 10.2414 6.95749 10.085 6.51896 9.79202C6.08043 9.49901 5.73863 9.08253 5.5368 8.59526C5.33496 8.10799 5.28216 7.57181 5.38505 7.05453C5.48794 6.53725 5.74192 6.06209 6.11486 5.68915C6.4878 5.31621 6.96295 5.06224 7.48024 4.95934C7.99752 4.85645 8.5337 4.90926 9.02097 5.11109C9.50824 5.31293 9.92471 5.65472 10.2177 6.09325C10.5107 6.53178 10.6671 7.04735 10.6671 7.57477C10.6671 8.28201 10.3862 8.96029 9.8861 9.46039C9.386 9.96049 8.70772 10.2414 8.00048 10.2414ZM8.00048 6.24144C7.73677 6.24144 7.47898 6.31964 7.25972 6.46614C7.04045 6.61265 6.86955 6.82089 6.76864 7.06453C6.66772 7.30816 6.64132 7.57625 6.69276 7.83489C6.74421 8.09353 6.8712 8.33111 7.05767 8.51758C7.24414 8.70405 7.48172 8.83104 7.74036 8.88248C7.999 8.93393 8.26709 8.90753 8.51072 8.80661C8.75436 8.70569 8.96259 8.5348 9.1091 8.31553C9.25561 8.09627 9.33381 7.83848 9.33381 7.57477C9.33381 7.22115 9.19334 6.88201 8.94329 6.63196C8.69324 6.38191 8.3541 6.24144 8.00048 6.24144Z" fill="#737373"/>
              <path d="M8.00048 15.5748C7.90205 15.5747 7.80485 15.5529 7.71586 15.5108C7.62688 15.4687 7.54831 15.4075 7.48581 15.3314L3.98914 11.0821C3.92248 11.0074 3.84648 10.9141 3.77181 10.8154L3.69181 10.7181C3.66076 10.6805 3.63393 10.6396 3.61181 10.5961C3.0627 9.79989 2.74044 8.86933 2.67953 7.90404C2.61863 6.93875 2.82136 5.97507 3.26605 5.11615C3.71073 4.25723 4.38061 3.5354 5.204 3.02793C6.02738 2.52045 6.97327 2.24644 7.94041 2.23522C8.90756 2.224 9.85955 2.476 10.6945 2.96423C11.5294 3.45247 12.2159 4.15856 12.6804 5.00694C13.1448 5.85531 13.3699 6.81403 13.3314 7.78047C13.2929 8.74691 12.9923 9.6847 12.4618 10.4934C12.44 10.5393 12.4127 10.5823 12.3805 10.6214L12.2958 10.7248C12.1766 10.8878 12.048 11.0436 11.9105 11.1914L8.51581 15.3281C8.45356 15.4048 8.37503 15.4668 8.28591 15.5094C8.19678 15.5521 8.09929 15.5744 8.00048 15.5748ZM4.78381 9.94944L4.81514 9.98744C4.88181 10.0774 4.94381 10.1488 5.00514 10.2181L8.00048 13.8581L10.9058 10.3194C11.0252 10.1909 11.1365 10.0551 11.2391 9.91277L11.2891 9.8521L11.3065 9.82477C11.7188 9.22014 11.9574 8.51396 11.9962 7.78313C12.035 7.0523 11.8726 6.32482 11.5266 5.67992C11.1806 5.03501 10.6643 4.4974 10.0339 4.1256C9.4035 3.75381 8.68319 3.56209 7.95138 3.57133C7.21958 3.58056 6.50433 3.79039 5.88352 4.17797C5.26272 4.56555 4.76014 5.11603 4.43052 5.76946C4.1009 6.42289 3.95686 7.15423 4.0141 7.88385C4.07134 8.61347 4.32766 9.3134 4.75514 9.90744C4.76581 9.92166 4.77537 9.93566 4.78381 9.94944Z" fill="#737373"/>
            </svg>
            {{ property.address }}
          </p>

          <!-- Precio -->
          <div class="text-black text-3xl mb-2 mt-4">
            <!-- Valor de venta -->
            <div class="flex flex-wrap">
            <!-- Valor de venta -->
            <div
              v-if="property.type_movement_id == 1 || property.type_movement_id == 3 || property.type_movement_id == 5"
              class="w-full md:w-1/2 text-left md:text-left mb-4"
            >
              <span class="block text-base font-normal">
                <template v-if="property.type_movement_id === 3">Venta</template>
                <template v-else>{{ property.property_movement }}</template>
              </span>
              <span class="block text-3xl font-bold">
                {{ property.property_value }}
                <span class="text-xl font-semibold">{{ property.currency_code || property.currency }}</span>
              </span>
              <div class="text-base font-normal text-gray-900" v-if="property.has_commission_sale">Comisión {{ property.commission_sale_value }} %</div>
            </div>

            <!-- Valor de renta -->
            <div
              v-if="property.type_movement_id == 2 || property.type_movement_id == 3 || property.type_movement_id == 4"
              class="w-full md:w-1/2 text-left md:text-left mb-4"
            >
              <span class="block text-base font-normal">
                <template v-if="property.type_movement_id === 3">Renta</template>
                <template v-else>{{ property.property_movement }}</template>
              </span>
              <span class="block text-3xl font-bold">
                {{ property.rent_value }}
                <span class="text-xl font-semibold">{{ property.currency_code || property.currency }}</span>
              </span>
              <div class="text-base font-normal text-gray-900" v-if="property.has_commission_rent">Comisión {{ property.commission_rent_value }} %</div>
            </div>
          </div>
            <!-- Mantenimiento -->
            <div
              v-show="property.include_maintenance == 0 && property.maintenance_value != '$0'"
              class="text-base text-black font-medium mb-2"
            >
              <span class="block font-semibold">Mantenimiento</span>
              <span class="block font-bold text-lg">
                {{ property.maintenance_value }}
                <span class="text-base font-semibold">{{ property.currency }}</span>
              </span>
            </div>
            <div
              v-show="!property.include_maintenance == 0"
              class="text-base text-black font-medium mb-2"
            >
              <span class="block font-semibold">Mantenimiento incluido</span>
            </div>
          </div>
        </div>
          <div class="only-mob mt-5">
            <div class="space-y-2">
              <!-- Características -->
              <div class="border-b border-gray-200">
                <button 
                  @click="toggleAccordion('caracteristicas')"
                  class="flex items-center justify-between w-full py-4 px-4 font-medium text-xl text-black"
                >
                  <span>Características</span>
                  <svg 
                    :class="['w-4 h-4 transition-transform duration-200', accordionStates.caracteristicas ? 'rotate-0' : '']"
                    aria-hidden="true" 
                    xmlns="http://www.w3.org/2000/svg" 
                    fill="none" 
                    viewBox="0 0 10 6"
                  >
                    <g transform="rotate(180 5 3)">
                      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5 5 1 1 5"/>
                    </g>
                  </svg>
                </button>
                <div 
                  v-show="accordionStates.caracteristicas"
                  class="p-4 border-t border-gray-200"
                >
                  <CardCharactersComponent 
                    :list="characters_list"
                    :property="property" 
                  />
                </div>
              </div>

              <!-- Descripción -->
              <div v-if="description != '<p> </p'" class="border-b border-gray-200">
                <button 
                  @click="toggleAccordion('descripcion')"
                  class="flex items-center justify-between w-full py-4 px-4 font-medium text-xl text-black"
                >
                  <span>Descripción</span>
                  <svg 
                    :class="['w-4 h-4 transition-transform duration-200', accordionStates.descripcion ? 'rotate-0' : '']"
                    aria-hidden="true" 
                    xmlns="http://www.w3.org/2000/svg" 
                    fill="none" 
                    viewBox="0 0 10 6"
                  >
                    <g transform="rotate(180 5 3)">
                      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5 5 1 1 5"/>
                    </g>
                  </svg>
                </button>
                <div 
                  v-show="accordionStates.descripcion"
                  class="p-4 border-t border-gray-200"
                >
                  <div class="relative w-full">
                    <div v-if="!showFullDescription">
                      <span>{{ descriptionTruncated }}</span>
                    </div>
                    <div v-else v-html="description" />
                    <button
                      v-if="descriptionPlain.length > maxDescriptionLength"
                      @click="showFullDescription = !showFullDescription"
                      class="mt-2 text-tuin-100 font-medium text-sm hover:underline"
                    >
                      {{ showFullDescription ? 'Ver menos' : 'Ver más' }}
                    </button>
                  </div>
                </div>
              </div>

              <!-- Otras características -->
              <div v-if="characters_additional != '<p> </p>' && characters_additional != null" class="border-b border-gray-200">
                <button 
                  @click="toggleAccordion('otras_caracteristicas')"
                  class="flex items-center justify-between w-full py-4 px-4 font-medium text-xl text-black"
                >
                  <span>Otras características</span>
                  <svg 
                    :class="['w-4 h-4 transition-transform duration-200', accordionStates.otras_caracteristicas ? 'rotate-0' : '']"
                    aria-hidden="true" 
                    xmlns="http://www.w3.org/2000/svg" 
                    fill="none" 
                    viewBox="0 0 10 6"
                  >
                    <g transform="rotate(180 5 3)">
                      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5 5 1 1 5"/>
                    </g>
                  </svg>
                </button>
                <div 
                  v-show="accordionStates.otras_caracteristicas"
                  class="p-4 border-t border-gray-200"
                >
                  <div class="relative w-full">
                    <div v-if="!showFullCharacteristics">
                      <span>{{ characteristicsTruncated }}</span>
                    </div>
                    <div v-else v-html="characters_additional" />
                    <button
                      v-if="characteristicsPlain.length > maxCharacteristicsLength"
                      @click="showFullCharacteristics = !showFullCharacteristics"
                      class="mt-2 text-tuin-100 font-medium text-sm hover:underline"
                    >
                      {{ showFullCharacteristics ? 'Ver menos' : 'Ver más' }}
                    </button>
                  </div>
                </div>
              </div>

              <!-- Amenidades -->
              <div v-if="amenities_list.length > 0" class="border-b border-gray-200">
                <button 
                  @click="toggleAccordion('amenidades')"
                  class="flex items-center justify-between w-full py-4 px-4 font-medium text-xl text-black"
                >
                  <span>Amenidades</span>
                  <svg 
                    :class="['w-4 h-4 transition-transform duration-200', accordionStates.amenidades ? 'rotate-0' : '']"
                    aria-hidden="true" 
                    xmlns="http://www.w3.org/2000/svg" 
                    fill="none" 
                    viewBox="0 0 10 6"
                  >
                    <g transform="rotate(180 5 3)">
                      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5 5 1 1 5"/>
                    </g>
                  </svg>
                </button>
                <div 
                  v-show="accordionStates.amenidades"
                  class="p-4 border-t border-gray-200"
                >
                  <CardAmenitiesComponent 
                    :list="amenities_list" 
                  />
                </div>
              </div>

              <!-- Friendly -->
              <div v-if="friendly_list.length > 0" class="border-b border-gray-200">
                <button 
                  @click="toggleAccordion('friendly')"
                  class="flex items-center justify-between w-full py-4 px-4 font-medium text-xl text-black"
                >
                  <span>Friendly</span>
                  <svg 
                    :class="['w-4 h-4 transition-transform duration-200', accordionStates.friendly ? 'rotate-0' : '']"
                    aria-hidden="true" 
                    xmlns="http://www.w3.org/2000/svg" 
                    fill="none" 
                    viewBox="0 0 10 6"
                  >
                    <g transform="rotate(180 5 3)">
                      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5 5 1 1 5"/>
                    </g>
                  </svg>
                </button>
                <div 
                  v-show="accordionStates.friendly"
                  class="p-4 border-t border-gray-200"
                >
                  <CardFriendlyComponent 
                    :list="friendly_list" 
                  />
                </div>
              </div>

              <!-- Requisitos -->
              <div v-if="requirement_list.length > 0" class="border-b border-gray-200">
                <button 
                  @click="toggleAccordion('requisitos')"
                  class="flex items-center justify-between w-full py-4 px-4 font-medium text-xl text-black"
                >
                  <span>Requisitos</span>
                  <svg 
                    :class="['w-4 h-4 transition-transform duration-200', accordionStates.requisitos ? 'rotate-0' : '']"
                    aria-hidden="true" 
                    xmlns="http://www.w3.org/2000/svg" 
                    fill="none" 
                    viewBox="0 0 10 6"
                  >
                    <g transform="rotate(180 5 3)">
                      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5 5 1 1 5"/>
                    </g>
                  </svg>
                </button>
                <div 
                  v-show="accordionStates.requisitos"
                  class="p-4 border-t border-gray-200"
                >
                  <CardRequirementComponent 
                    :list="requirement_list" 
                  />
                </div>
              </div>

              <!-- Servicios -->
              <div v-if="services_list.length > 0" class="border-b border-gray-200">
                <button 
                  @click="toggleAccordion('servicios')"
                  class="flex items-center justify-between w-full py-4 px-4 font-medium text-xl text-black"
                >
                  <span>Servicios</span>
                  <svg 
                    :class="['w-4 h-4 transition-transform duration-200', accordionStates.servicios ? 'rotate-0' : '']"
                    aria-hidden="true" 
                    xmlns="http://www.w3.org/2000/svg" 
                    fill="none" 
                    viewBox="0 0 10 6"
                  >
                    <g transform="rotate(180 5 3)">
                      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5 5 1 1 5"/>
                    </g>
                  </svg>
                </button>
                <div 
                  v-show="accordionStates.servicios"
                  class="p-4 border-t border-gray-200"
                >
                  <CardServicesComponent 
                    :list="services_list" 
                  />
                </div>
              </div>

              <!-- Video -->
              <div v-if="property.video_url" class="border-b border-gray-200">
                <button 
                  @click="toggleAccordion('video')"
                  class="flex items-center justify-between w-full py-4 px-4 font-medium text-xl text-black"
                >
                  <span>Video</span>
                  <svg 
                    :class="['w-4 h-4 transition-transform duration-200', accordionStates.video ? 'rotate-0' : '']"
                    aria-hidden="true" 
                    xmlns="http://www.w3.org/2000/svg" 
                    fill="none" 
                    viewBox="0 0 10 6"
                  >
                    <g transform="rotate(180 5 3)">
                      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5 5 1 1 5"/>
                    </g>
                  </svg>
                </button>
                <div 
                  v-show="accordionStates.video"
                  class="p-4 border-t border-gray-200"
                >
                  <CardVideoComponent :property="property" />
                </div>
              </div>

              <!-- Mapa -->
              <div v-if="property && property.property_lt && property.property_ln" class="border-b border-gray-200">
                <button 
                  @click="toggleAccordion('mapa')"
                  class="flex items-center justify-between w-full py-4 px-4 font-medium text-xl text-black"
                >
                  <span>Mapa</span>
                  <svg 
                    :class="['w-4 h-4 transition-transform duration-200', accordionStates.mapa ? 'rotate-0' : '']"
                    aria-hidden="true" 
                    xmlns="http://www.w3.org/2000/svg" 
                    fill="none" 
                    viewBox="0 0 10 6"
                  >
                    <g transform="rotate(180 5 3)">
                      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5 5 1 1 5"/>
                    </g>
                  </svg>
                </button>
                <div 
                  v-show="accordionStates.mapa"
                  class="p-4 border-t border-gray-200"
                >
                  <div
                    ref="mapRefMobile"
                    style="width: 100%; height: 300px"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="only-dest">
            <!-- Caracteristicas section -->
            <div id="caracteristicas" class="flex flex-wrap mt-2 pb-8 border-b border-[#E5E7EB]">
              <CardCharactersComponent 
                :list="characters_list"
                :property="property" 
              />
            </div>

            <!-- Description -->
            <div
              v-if="description != '<p> </p>'"
              id="descripcion"
              class="flex flex-wrap mt-8 pb-8 border-b border-[#E5E7EB]"
            >
              <fwb-heading tag="h3" class="font-medium text-xl mb-4">
                Descripción
              </fwb-heading>
              <div class="relative w-full">
                <div v-if="!showFullDescription">
                  <span>{{ descriptionTruncated }}</span>
                </div>
                <div v-else v-html="description" />
                <button
                  v-if="descriptionPlain.length > maxDescriptionLength"
                  @click="showFullDescription = !showFullDescription"
                  class="mt-2 text-tuin-100 font-medium text-sm hover:underline"
                >
                  {{ showFullDescription ? 'Ver menos' : 'Ver más' }}
                </button>
              </div>
            </div>

            <!-- Otras caracteristicas -->
            <div
              v-if="characters_additional != '<p> </p>' && characters_additional != null "
              id="additional_characteristics"
              class="flex flex-wrap mt-8 pb-8 border-b border-[#E5E7EB]"
            >
              <fwb-heading 
                v-show="characters_additional != null "
                class="font-medium text-xl mb-4"
              > 
                Otras características 
              </fwb-heading>
              <div class="relative w-full">
                <div v-if="!showFullCharacteristics">
                  <span>{{ characteristicsTruncated }}</span>
                </div>
                <div v-else v-html="characters_additional" />
                <button
                  v-if="characteristicsPlain.length > maxCharacteristicsLength"
                  @click="showFullCharacteristics = !showFullCharacteristics"
                  class="mt-2 text-tuin-100 font-medium text-sm hover:underline"
                >
                  {{ showFullCharacteristics ? 'Ver menos' : 'Ver más' }}
                </button>
              </div>
            </div>
            
            <!-- Amenidadaes -->
            <div id="amenidades">
              <CardAmenitiesComponent 
                v-show="amenities_list.length > 0"
                :list="amenities_list" 
              />
            </div>

            <!-- Friendly -->
            <div id="friendly">
              <CardFriendlyComponent 
                v-show="friendly_list.length > 0"
                :list="friendly_list" 
              />
            </div>

            <!-- Requirement -->
            <div id="requisitos">
              <CardRequirementComponent 
                v-show="requirement_list.length > 0"
                :list="requirement_list" 
              />
            </div>

            <!-- Servicios -->
            <div id="servicios">
              <CardServicesComponent 
                v-show="services_list.length > 0"
                :list="services_list" 
              />
            </div>

            <!-- Video -->
            <div v-if="property.video_url" id="video" class="w-full mt-4 border-b border-[#E5E7EB]">
              <CardVideoComponent :property="property" />
            </div>

            <!-- Mapa de ubicación  -->
            <div id="mapa" v-if="property && property.property_lt && property.property_ln" class="flex flex-wrap mt-8 bg-white mb-20">
              <fwb-heading tag="h4" class="font-medium text-xl mb-4">
                Mapa de ubicación
              </fwb-heading>
              <div
                ref="mapRef"
                style="width: 100%; height: 400px"
              />
            </div>
          </div> 
        </div>
        <!-- Fin Columna izquierda -->
        <!-- Columna derecha -->
        <div class="only-dest w-full lg:w-1/3 sticky top-32 h-fit">
          <div class="md:max-w-64 ml-auto flex justify-center items-center">
            <button class="flex items-center gap-2 text-center mb-8 mt-4 text-custom_gray text-sm font-medium hover:underline" @click="callActionLog(proeprtyId, 7, 'Usuario hizó clic en el botón de compartir propiedad desde Asesores'); showShareModal = true">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M13.5768 11.2506C13.0714 11.2528 12.5828 11.4387 12.1964 11.7756C12.156 11.7334 12.1115 11.6957 12.0634 11.6632L6.76943 8.79638C6.71613 8.77308 6.66042 8.75619 6.60339 8.74604C6.60948 8.68131 6.62252 8.61928 6.62252 8.55366C6.62252 8.54557 6.62252 8.53838 6.62252 8.53118C6.67974 8.525 6.73623 8.51295 6.79116 8.49522L11.9252 6.21631C11.976 6.18779 12.0238 6.15373 12.0677 6.11472C12.4287 6.4749 12.8989 6.69489 13.3988 6.73736C13.8987 6.77983 14.3974 6.64218 14.8104 6.34775C15.2233 6.05332 15.525 5.62024 15.6644 5.12197C15.8038 4.62369 15.7722 4.0909 15.575 3.61396C15.3779 3.13701 15.0272 2.74528 14.5826 2.50521C14.138 2.26514 13.6268 2.1915 13.1356 2.29679C12.6445 2.40208 12.2037 2.67981 11.888 3.08289C11.5723 3.48596 11.4012 3.98955 11.4036 4.50824C11.4032 4.51573 11.4032 4.52323 11.4036 4.53072C11.3463 4.5372 11.2898 4.54954 11.235 4.56758L6.10095 6.84559C6.0502 6.87433 6.00243 6.90837 5.95838 6.94718C5.65798 6.64068 5.27795 6.43101 4.8645 6.34365C4.45104 6.25629 4.02194 6.295 3.62936 6.45509C3.23678 6.61517 2.8976 6.88973 2.65306 7.24539C2.40851 7.60106 2.26912 8.02253 2.25183 8.45858C2.23454 8.89462 2.34008 9.32648 2.55564 9.70167C2.7712 10.0768 3.08749 10.3792 3.46608 10.572C3.84467 10.7648 4.26926 10.8397 4.68825 10.7877C5.10723 10.7356 5.50258 10.5588 5.82625 10.2788C5.86659 10.3211 5.91117 10.3587 5.95925 10.3912L11.2532 13.258C11.3055 13.2859 11.3606 13.3076 11.4175 13.3228C11.4175 13.3821 11.4001 13.4396 11.4001 13.5025C11.4001 13.9471 11.5276 14.3816 11.7664 14.7512C12.0052 15.1208 12.3446 15.4088 12.7417 15.5789C13.1388 15.749 13.5757 15.7935 13.9973 15.7068C14.4189 15.6201 14.8061 15.406 15.11 15.0917C15.414 14.7774 15.6209 14.377 15.7048 13.941C15.7886 13.505 15.7456 13.0532 15.5811 12.6425C15.4166 12.2318 15.1381 11.8808 14.7807 11.6339C14.4233 11.3869 14.0032 11.2551 13.5733 11.2551L13.5768 11.2506Z" fill="#737373"/>
              </svg>
              <p>Compartir propiedad</p>
            </button>
          </div>
          <!-- Contact -->
          <DetailCardBrokerComponent 
            :broker="property.agent"
            :property-id="proeprtyId"
            :slug-url="slug_url"
          />
        </div>
        <!-- Fin Columna derecha -->
      </div>
    </div>
    
    <!-- Componente flotante para móviles -->
    <div class="only-mob">
      <FloatingAgentMobile 
        v-if="property && property.agent"
        :property="property"
      />
    </div>
    <!-- Modales -->
    <ShareModal
      v-if="showShareModal"
      :slug_url="slug_url"
      :property="property"
      :property-id="proeprtyId"
      :session="session"
      @close="showShareModal = false"
      @copy-link="showToast('success', 'Enlace copiado al portapapeles')"
    />
    
    <ReportPropertyModal
      v-if="showReportModal"
      :is-active="showReportModal"
      :property-id="proeprtyId"
      :property-name="property.property_name"
      :report-reasons="reportReasons"
      :agent-id="property.agent ? property.agent.id : null"
      @close="showReportModal = false"
      @success="handleReportSuccess"
    />
    <SubscriptionExpiredModal
      :isVisible="showSubscriptionModal"
      @confirm="handleSubscriptionConfirm"
      @cancel="handleSubscriptionCancel"
    />
  </div>
</template>
  
<script setup>
// Add any script logic if needed
import { FwbHeading, } from "flowbite-vue";
import { Loader } from "@googlemaps/js-api-loader";

import { ref, computed, onMounted, nextTick, onBeforeUnmount } from "vue";
import axios from "axios";

import { useRoute } from "vue-router";
const route = useRoute();
import ToastAlert from '@/commond/ToastAlert.vue';

import { useStore } from "vuex";
import DetailCardBrokerComponent from "./DetailCardBrokerComponent.vue";
import CardMovementComponent from "./CardMovementComponent.vue";
import CardCharactersComponent from "./CardCharactersComponent.vue";
import CardAmenitiesComponent from "./CardAmenitiesComponent.vue";
import CardVideoComponent from "./CardVideoComponent.vue";
import CardFriendlyComponent from "./CardFriendlyComponent.vue";
import CardRequirementComponent from "./CardRequirementComponent.vue";
import CardServicesComponent from "./CardServicesComponent.vue";
import GalleryComponent from '@/components/common/GalleryComponent.vue';
import FloatingAgentMobile from "./FloatingAgentMobile.vue";
import ShareModal from './ShareModal.vue';
import ReportPropertyModal from './ReportPropertyModal.vue';
import SubscriptionExpiredModal from '@/components/properties/modal/SubscriptionExpiredModal.vue';
import { useRouter } from "vue-router";

const store = useStore();
let session = computed(() => store.getters.getUserSession);
let router = useRouter();

let loader = ref(false);
let proeprtyId = route.params.property_id;
let slug_url = ref({});
let property = ref({});
let pictures = ref([]);
let description = ref("<p></p>");
let characters_additional = ref("<p></p>");
let characters_list = [];
let amenities_list = [];
let friendly_list = [];
let requirement_list = [];
let services_list = [];
let showFullDescription = ref(false);
let showFullCharacteristics = ref(false);
let toastAlert = ref(false);
let typeMsg = ref("");
let msg = ref("");
const activeTab = ref('propiedad');

// Estados para los modales
const showReportModal = ref(false);
const showShareModal = ref(false);
const showSubscriptionModal = ref(false);
const subscriptionStatus = ref(null); 

// Estados para los acordeones móviles
const accordionStates = ref({
  caracteristicas: false,
  descripcion: false,
  otras_caracteristicas: false,
  amenidades: false,
  friendly: false,
  requisitos: false,
  servicios: false,
  video: false,
  mapa: false
});

// Referencia para el mapa móvil
const mapRefMobile = ref(null);

// Motivos de reporte precargados
const reportReasons = ref([]);

async function checkSubscription() {
    try {
      const options = {
        headers: {
          Authorization: `Bearer ${session.value.token_api}`,
        },
      };

      const response = await axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/broker/checkActive/${session.value.id}`,
        options
      );

      const data = response.data?.original;
      console.log(data)
      if (data) {
        const status = data.status;
        const planId = data.plan_id;
        
        // 🔹 Primero: validar que el status sea 'active'
        if (status !== 'active') {
          subscriptionStatus.value = 'expired';
          return;
        }

        // 🔹 Segundo: si el status es 'active', validar el plan_id
        if (planId === 9) {
          subscriptionStatus.value = 'expired';
          console.log(subscriptionStatus.value)
          return;
        }

        // ✅ Si pasa ambas validaciones, es válido
        subscriptionStatus.value = 'active';
      } else {
        subscriptionStatus.value = 'expired';
      }
    } catch (error) {
      console.error('Error al verificar suscripción:', error);
      subscriptionStatus.value = 'expired';
    }
  }
  function handleAddPropertyClick() {
    // Validar suscripción antes de ejecutar la acción
    if (subscriptionStatus.value !== 'active') {
      showSubscriptionModal.value = true;
      return; // Detener la ejecución
    }
    
    // Si la suscripción está activa, ejecutar la función normal
    addPropertyToProfile(proeprtyId);
    callActionLog(proeprtyId, 9, 'Usuario agregó propiedad a su perfil');
  }
  
  function handleSubscriptionConfirm() {
    showSubscriptionModal.value = false;
    router.push('/info-payments');
  }

  function handleSubscriptionCancel() {
    showSubscriptionModal.value = false;
  }

async function fetchReportReasons() {
  try {
    if (!session.value || !session.value.token_api) {
      console.error('No hay sesión o token_api');
      return;
    }
    let options = {
      headers: {
        Authorization: `Bearer ${session.value.token_api}`,
        'Content-Type': 'application/json'
      },
    };
    let link = `${process.env.VUE_APP_API_BASE_URL}/catalogue-reports`;
    const response = await axios.get(link, options);
    if (response.status === 200) {
      let motivos = response.data.resp;
      reportReasons.value = motivos.map(motivo => ({
        id: motivo.id,
        name: motivo.name,
        description: motivo.description
      }));
      //console.log('Motivos precargados:', reportReasons.value);
    }
  } catch (error) {
    console.error("Error fetching report reasons:", error);
  }
}

async function getDetail() {
  try {
    let options = {
      headers: {
        Authorization: `Bearer ${session.value.token_api}`,
      },
    };

    let link = `${process.env.VUE_APP_API_BASE_URL}/broker/exchange/property/${proeprtyId}`;

    const response = await axios.get(link, options);

    //console.log("✅ Respuesta completa:", response); // Ver todo
    if (response.status == 200) {
      property.value = response.data.info;
      slug_url.value = response.data.resp.general.slug_url;
      characters_list = response.data.resp.character_list;
      amenities_list = response.data.resp.amenities_list;
      friendly_list = response.data.resp.friendly_list;
      requirement_list = response.data.resp.requirement_list;
      services_list = response.data.resp.services_list;
      
      loader.value = false;

      pictures.value = response.data.resp.images;

      description.value = property.value.property_description;
      characters_additional.value = property.value.characteristics;
      callActionLog(proeprtyId, 1, "Asesor visito la propiedad");  
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}
async function callActionLog(property_id, type_action, detail){

let link = `${process.env.VUE_APP_API_BASE_URL}/event/add_log`;
let param_analytics = {
      "property_id":          property_id,
      "user_id":              session.value.id,
      "activity_id":          type_action,
      "description":          detail,          
}
console.log(param_analytics)

let options = {
  headers: {
    "Content-Type": "application/json"
  },
};

try {
  const response = await axios.post(link, param_analytics, options);

  if (response.status == 401) {
    //console.log("Hay que sacarlo de la sesion ");
  }

  if (response.status == 200) {
    console.log(response);
  }
  
} catch (error) {
  console.error("Error fetching data:", error);
}

}
//let loader_map;
const apiKey = "AIzaSyDh_2CwOWAcS258EwjQsctRq9ypVZfHAZw";
const mapRef = ref(null);

async function closeToast() {
  toastAlert.value = false;
  typeMsg.value = "";
  msg.value = "";
}

async function showToast(type, message){
  toastAlert.value = true;
  typeMsg.value = type;
  msg.value = message;

  setTimeout(() => {
    closeToast()
  }, 3000);
}

function handleReportSuccess(message) {
  showToast('success', message);
  callActionLog(proeprtyId, 8, 'Usuario reportó la propiedad');
}

async function addPropertyToProfile(property_id) {
  if (!session.value.id) {
    route.push({ name: "login" });
    return;
  }

  const post_params = {
    property_id: property_id,
    broker_id: session.value.id,
    is_owner: false,
  };

  let url = `${process.env.VUE_APP_API_BASE_URL}/broker/property/${session.value.id}/add_to_profile`;

  let options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${session.value.token_api}`,
    },
  };

  try {
    const response = await axios.post(url, post_params, options);

    if (response.status === 200) {
      showToast("success", response.data.message);
    } else {
      showToast("danger", "Hubo un error al agregar la propiedad");
    }
  } catch (error) {
    showToast("warning", "Esta propiedad ya la estás promocionando en tu catálogo.");
    console.log("Error al agregar la propiedad:", error);
    if (error.response && error.response.status === 401) {
      store.dispatch("clearUserSession");
      route.push({ name: "login" });
    }
  }
}

onMounted(async () => {
  loader.value = true;
  await getDetail();
  await fetchReportReasons();
  await checkSubscription();
  
  const loader_map = new Loader({
    apiKey: apiKey, // Reemplaza con tu clave de API
    libraries: ["places"], // Importante: Añade 'places' para Autocomplete
  });

  // loader_map.load().then(async () => {
  //   await initMap();
  // });
  try {
    // Espera a que Google Maps cargue
    const google = await loader_map.load();
    
    // Configuración del mapa
    const map = new google.maps.Map(mapRef.value, {
      center: {
        lat: property.value.property_lt,
        lng: property.value.property_ln,
      }, // Coordenadas iniciales (CDMX)
      zoom: 15, // Nivel de zoom
    });

    
    // Añadir un marcador al mapa
    new google.maps.Marker({
      position: {
        lat: property.value.property_lt,
        lng: property.value.property_ln,
      }, // Coordenadas del marcador
      map,
      title: `${property.value.property_name}`, // Texto al pasar el mouse sobre el marcador
      icon: {
        url: "https://tuin.ai/imgs/PinTuin.svg", // URL del ícono personalizado
        scaledSize: new google.maps.Size(50, 50), // Tamaño del ícono
        origin: new google.maps.Point(0, 0), // Origen del ícono
        anchor: new google.maps.Point(25, 50), // Punto de anclaje del ícono
      },
    });
  } catch (error) {
    console.error("Error al cargar Google Maps:", error);
  } finally {
    loader.value = false;
  }
});

function stripHtml(html) {
  // Quita etiquetas HTML y decodifica entidades básicas
  const tmp = document.createElement('div');
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || '';
}

function truncateText(text, maxLength) {
  if (text.length <= maxLength) return text;
  // Trunca sin cortar palabras
  let truncated = text.slice(0, maxLength);
  if (text[maxLength] !== ' ' && truncated.lastIndexOf(' ') > 0) {
    truncated = truncated.slice(0, truncated.lastIndexOf(' '));
  }
  return truncated + '...';
}

const maxDescriptionLength = 450;
const maxCharacteristicsLength = 450;

const descriptionPlain = computed(() => stripHtml(description.value || ''));
const descriptionTruncated = computed(() => truncateText(descriptionPlain.value, maxDescriptionLength));

const characteristicsPlain = computed(() => stripHtml(characters_additional.value || ''));
const characteristicsTruncated = computed(() => truncateText(characteristicsPlain.value, maxCharacteristicsLength));

function scrollToSection(sectionId) {
  activeTab.value = sectionId;
  const el = document.getElementById(sectionId);
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

// Función para alternar el estado de los acordeones
function toggleAccordion(sectionId) {
  // Si el acordeón ya está abierto, lo cerramos
  if (accordionStates.value[sectionId]) {
    accordionStates.value[sectionId] = false;
  } else {
    // Cerramos todos los acordeones primero
    Object.keys(accordionStates.value).forEach(key => {
      accordionStates.value[key] = false;
    });
    // Abrimos solo el acordeón seleccionado
    accordionStates.value[sectionId] = true;
    
    // Si se abre el mapa, inicializar el mapa móvil
    if (sectionId === 'mapa' && mapRefMobile.value) {
      nextTick(() => {
        initMobileMap();
      });
    }
  }
}

// Función para inicializar el mapa móvil
async function initMobileMap() {
  if (!mapRefMobile.value || !property.value.property_lt || !property.value.property_ln) return;
  
  try {
    const loader_map = new Loader({
      apiKey: apiKey,
      libraries: ["places"],
    });

    const google = await loader_map.load();
    
    const map = new google.maps.Map(mapRefMobile.value, {
      center: {
        lat: property.value.property_lt,
        lng: property.value.property_ln,
      },
      zoom: 15,
    });

    new google.maps.Marker({
      position: {
        lat: property.value.property_lt,
        lng: property.value.property_ln,
      },
      map,
      title: `${property.value.property_name}`,
      icon: {
        url: "https://tuin.ai/imgs/PinTuin.svg",
        scaledSize: new google.maps.Size(50, 50),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(25, 50),
      },
    });
  } catch (error) {
    console.error("Error al cargar Google Maps móvil:", error);
  }
}

const sectionIds = [
  'propiedad',
  'caracteristicas',
  'descripcion',
  'additional_characteristics',
  'amenidades',
  'friendly',
  'requisitos',
  'servicios',
  'video',
  'mapa'
];

function onScrollSpy() {
  for (const id of sectionIds) {
    const el = document.getElementById(id);
    if (el) {
      const rect = el.getBoundingClientRect();
      if (rect.top <= 80 && rect.bottom > 80) {
        activeTab.value = id;
        break;
      }
    }
  }
}

onMounted(() => {
  window.addEventListener('scroll', onScrollSpy, { passive: true });
});

onBeforeUnmount(() => {
  window.removeEventListener('scroll', onScrollSpy);
});
</script>
  
<style>
/* Add custom styles if required */
#propiedad,
#caracteristicas,
#descripcion,
#additional_characteristics,
#amenidades,
#friendly,
#requisitos,
#servicios,
#video,
#mapa {
  scroll-margin-top: 70px;
}

@media (max-width: 1224px) {
  .only-dest { display: none !important; }
  .only-mob { display: block !important; }
}
@media (min-width: 1225px) {
  .only-dest { display: block !important; }
  .only-mob { display: none !important; }
}
</style>
  